export default "__VITE_PUBLIC_ASSET__8329f8aa__"